import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

/**
 * Функция замены инвентаризационных объектов
 */
export const useSendInventObjectReplace = () => {
  const http = useHttp()

  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.file(`/inventory/objects/replace`, data)
    },
  })

  const send = async (data: any) => {
    return mutation
      .mutateAsync(data)
      .then(() => {
        addSuccess(trs('itf.saved'))
      })
      .catch((error: any) => {
        addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
      })
  }

  return {
    ...mutation,

    send,
  }
}
